/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import '../plugins';
import 'select2';
import '../jquery.form-repeater.js';
// import './js/jquery';
// import './js/custom';
// import './plugins/slider-pro/jquery.sliderPro.min';
// import './plugins/owl-carousel/owl.carousel.min';
// import './plugins/magnific-popup/jquery.magnific-popup.min';
// import './plugins/bootstrap-select/dist/js/bootstrap-select.min';
// import './plugins/doubletaptogo';
// import './plugins/waypoints.min';
// import './plugins/flowplayer/flowplayer.min';
// import './plugins/classie';
// import './plugins/scrollreveal/scrollreveal.min';
// import './plugins/jarallax/jarallax.min';
// import './plugins/rendro-easy-pie-chart/dist/jquery.easypiechart.min';


import Vue from 'vue';

window.Vue = Vue;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});